module.exports = "data:application/octet-stream;base64,cHJhZ21hIHNvbGlkaXR5IF4wLjUuMDsKCmltcG9ydCAnLi4vLi4vaGVscGVycy9Pd25hYmxlLTA1LnNvbCc7Cgpjb250cmFjdCBMZXZlbCBpcyBPd25hYmxlIHsKICBmdW5jdGlvbiBjcmVhdGVJbnN0YW5jZShhZGRyZXNzIF9wbGF5ZXIpIHB1YmxpYyBwYXlhYmxlIHJldHVybnMgKGFkZHJlc3MpOwogIGZ1bmN0aW9uIHZhbGlkYXRlSW5zdGFuY2UoYWRkcmVzcyBwYXlhYmxlIF9pbnN0YW5jZSwgYWRkcmVzcyBfcGxheWVyKSBwdWJsaWMgcmV0dXJucyAoYm9vbCk7Cn0K"


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/base/Level-05.sol
// module id = 1857
// module chunks = 0